import FormValidator from "./FormValidator";

export default new class Form {
	init() {
		this.initFormContact();
		this.initFormCompany();
	}

	initFormContact() {
		// Envoie du formulaire
        const formSend = async () => {
            const form = document.querySelector('#contactForm');
            const url = form.getAttribute('action') ?? window.location.href;
            const data = new FormData(form);

            await fetch(url, {
                method: 'POST',
                body: data,
                redirect: 'follow'
            })
            .then(response => response.json())
            .then(result => {
                if(result.status === 200) {
                    form.querySelector('.success').style.display = 'inline-block';
                    form.reset();
                } else if (result.status === 400) {
                    form.querySelector('.form__message .error-1').style.display = 'inline-block';
                } else if (result.status === 429) {
                    form.querySelector('.form__message .error-3').style.display = 'inline-block';
                } else if (result.status === 427) {
                    form.querySelector('.form__message .error-4').style.display = 'inline-block';
                } else if (result.status === 431) {
                    form.querySelector('.form__message .error-5').style.display = 'inline-block';
                } else {
                    form.querySelector('.form__message .error-2').style.display = 'inline-block';
                }
            })
            .catch(error => console.error('error', error));
        };

        // Validation du formulaire
        const fields = [
            ['text', '#contact_firstname', '#contact_firstname'],
            ['text', '#contact_lastname', '#contact_lastname'],
            ['text', '#contact_company', '#contact_company'],
            ['email', '#contact_email', '#contact_email'],
            ['text', '#contact_subject', '#contact_subject'],
            ['text', '#contact_message', '#contact_message'],
            ['checkbox', '#contact_acceptance', '#contact_acceptance'],
        ];

        new FormValidator('#contactForm', fields, {
            afterValidationSuccess : formSend,
        });
	}

	initFormCompany() {
		// Envoie du formulaire
        const formSend = async () => {
            const form = document.querySelector('#contactCompanyForm');
            const url = form.getAttribute('action') ?? window.location.href;
            const data = new FormData(form);

            await fetch(url, {
                method: 'POST',
                body: data,
                redirect: 'follow'
            })
            .then(response => response.json())
            .then(result => {
                if(result.status === 200) {
                    document.location = 'https://www.thegenzshift.com/thank-you-bulk-orders/';
                    // form.querySelector('.success').style.display = 'inline-block';
                    form.reset();
                } else if (result.status === 400) {
                    form.querySelector('.form__message .error-1').style.display = 'inline-block';
                } else if (result.status === 429) {
                    form.querySelector('.form__message .error-3').style.display = 'inline-block';
                } else if (result.status === 427) {
                    form.querySelector('.form__message .error-4').style.display = 'inline-block';
                } else if (result.status === 431) {
                    form.querySelector('.form__message .error-5').style.display = 'inline-block';
                } else {
                    form.querySelector('.form__message .error-2').style.display = 'inline-block';
                }
            })
            .catch(error => console.error('error', error));
        };

        // Validation du formulaire
        const fields = [
            ['text', '#contact_firstname', '#contact_firstname'],
            ['text', '#contact_lastname', '#contact_lastname'],
            ['text', '#contact_company', '#contact_company'],
            ['email', '#contact_email', '#contact_email'],
            ['text', '#contact_nb_copies', '#contact_nb_copies'],
            ['text', '#contact_country_delivery', '#contact_country_delivery'],
            ['checkbox', '#contact_acceptance', '#contact_acceptance'],
        ];

        new FormValidator('#contactCompanyForm', fields, {
            afterValidationSuccess : formSend,
        });
	}
}